import type { BasketProposal } from '../../store/modules/interfaces/ProposalBasketStoreState';
import type { TrackingObject } from './types/TagManager';

export default class ProposalBasket {
  private model: BasketProposal[];

  constructor(model: BasketProposal[]) {
    this.model = model;
  }

  get(event: string): TrackingObject | null {
    let trackingObject: TrackingObject | null = null;
    const trackEvent = 'track-event';
    const eventCategory = 'Min side kurv';

    switch (event) {
      case 'proposal-basket-add-insurance': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'CTA klik - Næste',
          eventLabel: `${JSON.stringify(this.model.map((p) => p.productType))}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }

      case 'proposal-basket-continue': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'CTA klik - Tilføj anden forsikring',
          eventLabel: 'Tilføj anden forsikring',
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }
    }

    return trackingObject;
  }
}
